export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/500/img-server-error-light-5ab0d44389bd500d46a71cd215081fed.svg";